import { i18n } from "@lingui/core";
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import * as Bento from '@prezi/bento';
import { blue500 } from '@prezi/common-design';
import { viewLinkActions } from '../../../../store/actions/viewLinkActions';
import { getViewlinkUrl } from '../../../../api/viewlink';
import { Icons } from '../../../atoms';
import { ColumnMinAuto, RowGap, RowGrid, SmallLabel } from '../../../atoms/dumb';
import { ViewLinkCopySecondary } from '../../../molecules/dumb';
import { isActive } from '../../../../featureswitches/Features';
const LinkTitleContainer = styled(ColumnMinAuto).withConfig({
  displayName: "LinkList__LinkTitleContainer",
  componentId: "cjhdmt-0"
})(["cursor:pointer;", "{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;", "}svg{path{", "}}"], Bento.Body1, p => p.isHovered && `color: ${blue500}`, p => p.isHovered && `fill: ${blue500}`);
const LinkNameWrapper = styled.div.withConfig({
  displayName: "LinkList__LinkNameWrapper",
  componentId: "cjhdmt-1"
})(["display:flex;flex-direction:row;justify-content:start;align-items:center;column-gap:8px;color:#646464;"]);
const LinkTitle = ({
  name,
  handleOnClick,
  disabled,
  onHoverIcon,
  createdBy,
  showCreatedBy
}) => {
  const [isHovered, setIsHovered] = React.useState(false);
  return React.createElement(LinkTitleContainer, {
    isHovered: isHovered,
    onClick: handleOnClick,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    tabIndex: 0
  }, !disabled && isHovered && onHoverIcon, !isHovered && React.createElement(Icons.Link, null), React.createElement(LinkNameWrapper, null, React.createElement(Bento.Body2, null, name), showCreatedBy && createdBy && React.createElement(SmallLabel, null, createdBy)));
};
const LinkList = ({
  links,
  documentSchemaVersionName,
  handleOnClick,
  disabled
}) => {
  var _referralState$value, _referralState$value$, _referralState$value2, _referralState$value3;
  const dispatch = useDispatch();
  const referralState = useSelector(state => state.referral);
  const showReferralInfo = useSelector(state => state.showReferralCopyAndCode);
  const shouldAddReferralToken = showReferralInfo && (referralState === null || referralState === void 0 ? void 0 : (_referralState$value = referralState.value) === null || _referralState$value === void 0 ? void 0 : (_referralState$value$ = _referralState$value.tokens) === null || _referralState$value$ === void 0 ? void 0 : _referralState$value$.ln) && isActive('gm-share-modal-share-link-improvements');
  const referralToken = shouldAddReferralToken ? referralState === null || referralState === void 0 ? void 0 : (_referralState$value2 = referralState.value) === null || _referralState$value2 === void 0 ? void 0 : (_referralState$value3 = _referralState$value2.tokens) === null || _referralState$value3 === void 0 ? void 0 : _referralState$value3.ln : undefined;
  return React.createElement(RowGrid, {
    rowGap: RowGap.small
  }, links.map(({
    link_id: linkId,
    name,
    is_owner: isOwner,
    sharer_first_name: sharerFirstName,
    sharer_last_name: sharerLastName
  }) => {
    const viewLink = getViewlinkUrl(linkId, documentSchemaVersionName, referralToken);
    return React.createElement(RowGrid, {
      rowGap: RowGap.none,
      key: linkId
    }, React.createElement(LinkTitle, {
      handleOnClick: () => handleOnClick(linkId),
      name: name,
      disabled: disabled,
      onHoverIcon: isOwner ? React.createElement(Icons.Edit, null) : React.createElement(Icons.Trash, null),
      createdBy: isOwner && !sharerFirstName && !sharerLastName ? undefined : i18n._("Created by {sharerFirstName} {sharerLastName}", {
        sharerFirstName: sharerFirstName,
        sharerLastName: sharerLastName
      }),
      showCreatedBy: !isOwner
    }), React.createElement(ViewLinkCopySecondary, {
      viewLink: viewLink,
      handleCopyToClipboard: () => dispatch(viewLinkActions.copyToClipboard(viewLink))
    }));
  }));
};
export default LinkList;